// extracted by mini-css-extract-plugin
module.exports = {"icon":"DropDownListIcon_icon__1p9yA","selectGroup":"DropDownListIcon_selectGroup__3xkd2","selectIcon":"DropDownListIcon_selectIcon__MB1NT"};